module.exports = __webpack_public_path__ + "img/border-1--active.1714046b.svg";